import React, { useEffect, useState } from 'react'

import ScreenSizeContext from 'common/contexts/screen-size'
import debounce from 'lodash.debounce'

function getSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}

function ScreenSizeListener({ children }) {
  const [size, setSize] = useState(getSize)

  useEffect(() => {
    const onResizeHandler = debounce(function onResizeHandler() {
      setSize(getSize)
    }, 100)

    window.addEventListener('resize', onResizeHandler, false)

    return () => {
      window.removeEventListener('resize', onResizeHandler)
    }
  }, [])

  return <ScreenSizeContext.Provider value={size}>{children}</ScreenSizeContext.Provider>
}

export default ScreenSizeListener
